import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'

export interface AppointmentChannelInterface {
  channelName: string
  channelNameEn?: string
  status: string
}

export default class AppointmentChannelApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('appointment-channels', { params: { ...props } }).then((res) => res)
  }

  static create(channelName: string, channelNameEn: string) {
    return this.api.post('appointment-channels', { channelName, channelNameEn })
  }

  static findById(id: number): Promise<AppointmentChannelInterface> {
    return this.api.get(`appointment-channels/${id}`)
  }

  static update(id: number, body: AppointmentChannelInterface) {
    return this.api.patch(`appointment-channels/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`appointment-channels/${id}/status`, { id, status })
  }

  static remove(id: number) {
    return this.api.delete(`appointment-channels/${id}`)
  }
}
